'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.init = init;

var _listeners = require('../utils/listeners');

var _reactiveState = require('../utils/reactive-state');

var _functional = require('../utils/functional');

var _images = require('../utils/images');

var _utils = require('../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var ScrollDirections = {
  DOWN: 'DOWN',
  UP: 'UP'
};

var SessionNames = {
  ANNOUNCEMENT_BAR_BOTTOM_HIDE: 'HY::HIDE_ANNOUCEMENT_BOTTOM'
};

var classes = {
  HIDE_TABS: 'hd-Header-hideTabs',
  ROOT_SHOW_TABS: 'hd-Body-showTabs'
};

function init(_ref) {
  var _shrinkTriggerPoints, _triggerPoints;

  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    root: document.documentElement,
    header: (0, _functional.getElement)('.js-Header'),
    tabs: (0, _functional.getElement)('.js-Header_Tabs'),
    banner: (0, _functional.getElement)('.js-Header_Banner'),
    mainWrapper: (0, _functional.getElement)('.js-Header_Main'),
    mobileMenu: (0, _functional.getElement)('.js-Header_Drawer'),
    mobileMenuBackdrop: (0, _functional.getElement)('.js-Header_Backdrop'),
    announcementBarTop: context.getElement('.' + context.className + '_AnnouncementBarTop'),
    announcementBarBottom: context.getElement('.' + context.className + '_AnnouncementBarBottom'),
    announcementBarBottomRemove: context.getElement('.' + context.className + '_AnnouncementBarBottomRemove'),
    search: context.getElement('.' + context.className + '_Search'),
    desktopNavigation: context.getElement('.hd-Banner_Nav-left .hd-Navigation')
  };

  var options = {
    safeArea: 130,
    shrinkTriggerPoints: (_shrinkTriggerPoints = {}, (0, _defineProperty3.default)(_shrinkTriggerPoints, ScrollDirections.DOWN, 150), (0, _defineProperty3.default)(_shrinkTriggerPoints, ScrollDirections.UP, -150), _shrinkTriggerPoints),
    triggerPoints: (_triggerPoints = {}, (0, _defineProperty3.default)(_triggerPoints, ScrollDirections.DOWN, 150), (0, _defineProperty3.default)(_triggerPoints, ScrollDirections.UP, -150), _triggerPoints)
  };

  var state = new _reactiveState.ReactiveState({
    isSmallNav: true,
    isBottomBarHidden: false,
    isTabsHidden: false,
    scrollDirection: null,
    imagesLoaded: false
  });

  state.subscribe('isSmallNav', onIsSmallChange);
  state.subscribe('isBottomBarHidden', onIsBottomBarHiddenChange);
  state.subscribe('isTabsHidden', onIsTabsHiddenChange);
  state.subscribe('scrollDirection', onScrollDirectionChange);
  state.subscribe('imagesLoaded', onImagesLoadedChange);

  setHeight();
  setVisibleHeight({ isBottomBarHidden: state.isBottomBarHidden, isTabsHidden: state.isTabsHidden });
  window.addEventListener('resize', function () {
    setHeight();
    setVisibleHeight({
      isBottomBarHidden: state.isBottomBarHidden,
      isTabsHidden: state.isTabsHidden
    });
  });

  // Removes the bottom annoucement bar if the Session Storage variable is set
  if (sessionStorage.getItem(SessionNames.ANNOUNCEMENT_BAR_BOTTOM_HIDE)) {
    onAnnouncementBarBottomRemove();
  }

  var listeners = new _listeners.Listeners();
  listeners.add(window, 'scroll', onScroll);

  if (els.desktopNavigation) {
    listeners.add(els.desktopNavigation, 'mouseenter', onNavigationHover);
  }

  if (els.announcementBarBottomRemove) {
    listeners.add(els.announcementBarBottomRemove, 'click', onAnnouncementBarBottomRemove);
  }

  var isTicking = false;
  var lastKnownY = window.pageYOffset;
  var startPoint = void 0;
  var shrinkTriggerPoint = void 0;
  var triggerPoint = void 0;

  function onScroll() {
    state.scrollDirection = window.pageYOffset >= lastKnownY ? ScrollDirections.DOWN : ScrollDirections.UP;

    lastKnownY = window.pageYOffset;
    requestTick();
  }

  function requestTick() {
    if (!isTicking) window.requestAnimationFrame(updateEl);

    isTicking = true;
  }

  function updateEl() {
    isTicking = false;

    state.isSmallNav = function () {
      if (lastKnownY > options.safeArea) {
        if (state.scrollDirection === ScrollDirections.DOWN) {
          var scrollIsBetweenStartAndTriggerPoint = startPoint <= lastKnownY && lastKnownY < shrinkTriggerPoint;
          var scrollIsAfterTriggerPoint = lastKnownY >= shrinkTriggerPoint;

          if (scrollIsBetweenStartAndTriggerPoint) {
            return false;
          }

          if (scrollIsAfterTriggerPoint) {
            return true;
          }
        }

        if (state.scrollDirection === ScrollDirections.UP) {
          var scrollIsBeforeTriggerPoint = lastKnownY > shrinkTriggerPoint;
          var _scrollIsAfterTriggerPoint = lastKnownY <= shrinkTriggerPoint;

          if (scrollIsBeforeTriggerPoint) {
            return true;
          }

          if (_scrollIsAfterTriggerPoint) {
            return false;
          }
        }
      } else {
        return false;
      }
    }();

    state.isBottomBarHidden = function () {
      if (lastKnownY > options.safeArea) {
        if (state.scrollDirection === ScrollDirections.DOWN) {
          var scrollIsBetweenStartAndTriggerPoint = startPoint <= lastKnownY && lastKnownY < triggerPoint;
          var scrollIsAfterTriggerPoint = lastKnownY >= triggerPoint;

          if (scrollIsBetweenStartAndTriggerPoint) {
            return false;
          }

          if (scrollIsAfterTriggerPoint) {
            return true;
          }
        }

        if (state.scrollDirection === ScrollDirections.UP) {
          var scrollIsBeforeTriggerPoint = lastKnownY > triggerPoint;
          var _scrollIsAfterTriggerPoint2 = lastKnownY <= triggerPoint;

          if (scrollIsBeforeTriggerPoint) {
            return true;
          }

          if (_scrollIsAfterTriggerPoint2) {
            return false;
          }
        }
      } else {
        return false;
      }
    }();

    /**
     * Tabs should hide after scrolling down past the viewports height, but only show
     * again after scrolling all the way back up
     */
    state.isTabsHidden = function () {
      if (!(0, _utils.mediaBreakpointMatches)('xs') || !els.tabs) {
        return false;
      }
      if (state.scrollDirection === ScrollDirections.UP && startPoint - lastKnownY > options.shrinkTriggerPoints[ScrollDirections.DOWN]) {
        return false;
      }

      if (!state.isTabsHidden) {
        return lastKnownY > window.innerHeight && Math.abs(startPoint - lastKnownY) > options.shrinkTriggerPoints[ScrollDirections.DOWN];
      } else if (lastKnownY < 10) {
        return false;
      } else {
        return state.isTabsHidden;
      }
    }();
  }

  /**
   * Removes the bottom Anouncement Bar and updates the height of the CSS variable
   */
  function onAnnouncementBarBottomRemove() {
    els.announcementBarBottom.remove();
    els.announcementBarBottom = null;

    // Sets a Session Storgage variable that expires when the tab is closed
    sessionStorage.setItem(SessionNames.ANNOUNCEMENT_BAR_BOTTOM_HIDE, true);

    setHeight();
    setVisibleHeight({ isBottombarHidden: true, isTabsHidden: state.isTabsHidden });
  }

  function onIsSmallChange(value, _ref2) {
    var prevVal = _ref2.prevVal;

    if (!els.announcementBarTop) return;
    els.header.classList.toggle('hd-Header-moveBanner', value);
  }

  function onIsBottomBarHiddenChange(value, _ref3) {
    var prevVal = _ref3.prevVal;

    if (!els.announcementBarTop && !els.announcementBarBottom) return;
    if (value === prevVal) return;

    els.header.classList.toggle('hd-Header-hideAnnouncementBars', value);
    els.banner.classList.toggle('hd-Header_Hide', value);

    setVisibleHeight({ isBottomBarHidden: value, isTabsHidden: state.isTabsHidden });
    setHeight();
  }

  function onIsTabsHiddenChange(value, _ref4) {
    var prevVal = _ref4.prevVal;

    if (!els.tabs) return;
    if (value === prevVal) return;

    els.header.classList.toggle(classes.HIDE_TABS, value);
    els.root.classList.toggle(classes.ROOT_SHOW_TABS, !value);
    setVisibleHeight({ isBottomBarHidden: state.isBottomBarHidden, isTabsHidden: value });
  }

  function onScrollDirectionChange(value, _ref5) {
    var prevVal = _ref5.prevVal;

    var directionHasChanged = value !== prevVal;

    if (directionHasChanged) {
      startPoint = lastKnownY;
      shrinkTriggerPoint = startPoint + options.shrinkTriggerPoints[value];
      triggerPoint = startPoint + options.triggerPoints[value];
    }
  }

  function setHeight() {
    var announcementBarTopHeight = getElementHeight(els.announcementBarTop);
    var tabsHeight = getElementHeight(els.tabs, 0);
    var bannerHeight = getElementHeight(els.banner);
    var announcementBarBottomHeight = getElementHeight(els.announcementBarBottom, 0);

    var height = [announcementBarTopHeight, els.header.classList.contains('hd-Header-hideTabs') ? 0 : tabsHeight, bannerHeight, els.header.classList.contains('hd-Header-hideAnnouncementBars') ? 0 : announcementBarBottomHeight].reduce(function (acc, height) {
      return acc + height;
    }, 0);

    setCssVariable('--Header_Height', height + 'px');
  }

  /**
   * Set the visible height of the header
   * Used when the bottom announcement bar is hiding
   *
   */
  function setVisibleHeight(_ref6) {
    var isBottomBarHidden = _ref6.isBottomBarHidden,
        isTabsHidden = _ref6.isTabsHidden;

    var announcementBarTopHeight = getElementHeight(els.announcementBarTop);
    var tabsHeight = !isTabsHidden ? getElementHeight(els.tabs, 0) : 0;
    var bannerHeight = getElementHeight(els.banner);
    var announcementBarBottomHeight = !isBottomBarHidden ? getElementHeight(els.announcementBarBottom, 0) : 0;

    var height = [announcementBarTopHeight, bannerHeight, tabsHeight, announcementBarBottomHeight].reduce(function (acc, height) {
      return acc + height;
    }, 0);

    setCssVariable('--Visible_Header_Height', height + 'px');
  }

  function setCssVariable(variable, value) {
    els.root.style.setProperty(variable, value);
  }

  function onNavigationHover() {
    state.imagesLoaded = true;
  }

  function onImagesLoadedChange(value) {
    if (value) {
      (0, _images.loadImages)('.lazyload-navigation', els.header, 'lazyload-navigation');
      listeners.remove('mouseenter', onNavigationHover);
    }
  }
}

function getElementHeight(el) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;

  if (el) {
    return el.offsetHeight;
  }

  return fallback;
}